import { render } from "./Subprocessors.vue?vue&type=template&id=5d00cbca&scoped=true"
import script from "./Subprocessors.vue?vue&type=script&lang=js"
export * from "./Subprocessors.vue?vue&type=script&lang=js"

import "./Subprocessors.vue?vue&type=style&index=0&id=5d00cbca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d00cbca"]])

export default __exports__